import React from "react";

import {  Box, Typography } from '@material-ui/core';

import { Nav } from "../../components/Interface";

export const NotFound = () => {
  return (
    <>
      <Nav />

      <Box padding={3}>

        <h1>Not found</h1>
        <Typography>The page you are looking for does not exist.</Typography>

      </Box>
    </>
  );
  
}